import { Card, Grid, Stack, Text, Title } from '@mantine/core';
import { useCurrentUser } from '@/auth/AuthProvider';
import { ChangePasswordForm } from '@/features/auth/ChangePasswordForm';
import { notifySuccess } from '@/lib/notify';
import { useClientOptions } from './api';

export function ClientAccountPage() {
  const user = useCurrentUser();
  const options = useClientOptions();
  return (
    <Stack gap="md" maw={880}>
      <Stack gap={4}>
        <Title order={1} fz={{ base: 26, sm: 32 }} style={{ letterSpacing: '-0.015em' }}>
          Account
        </Title>
        <Text c="dimmed">Your login details. To change your name or email, contact your Makin account manager.</Text>
      </Stack>
      <Grid gutter="lg">
        <Grid.Col span={{ base: 12, md: 5 }}>
          <Card>
            <Stack gap="sm">
              <Title order={4}>Profile</Title>
              <Stack gap={2}>
                <Text fz="xs" c="dimmed">
                  Name
                </Text>
                <Text fw={600}>{user.fullName}</Text>
              </Stack>
              <Stack gap={2}>
                <Text fz="xs" c="dimmed">
                  Email
                </Text>
                <Text>{user.email}</Text>
              </Stack>
              <Stack gap={2}>
                <Text fz="xs" c="dimmed">
                  Company
                </Text>
                <Text>{options.data?.company.name ?? '—'}</Text>
              </Stack>
            </Stack>
          </Card>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 7 }}>
          <Card id="password">
            <Stack gap="md">
              <Title order={4}>Change password</Title>
              <ChangePasswordForm onDone={() => notifySuccess('Your password has been updated.')} />
            </Stack>
          </Card>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
